import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import { SettingsProvider } from "./context/SettingsContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import InfoPage from "./pages/InfoPage";
import PolicyPage from "./pages/PolicyPage";
import Admin from "./pages/Admin";
import ScrollToTop from "./components/ScrollToTop";
import AccessibilityWidget from "./components/AccessibilityWidget";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

function StoreLayout({ children }) {
  return (
    <>
      <Header />
      <main className="min-h-screen">{children}</main>
      <Footer />
      <FloatingWhatsApp />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div id="acc-root">
            <Routes>
              <Route path="/" element={<StoreLayout><Home /></StoreLayout>} />
              <Route path="/shop" element={<StoreLayout><Shop /></StoreLayout>} />
              <Route path="/shop/:category" element={<StoreLayout><Shop /></StoreLayout>} />
              <Route path="/sale" element={<StoreLayout><Shop sale /></StoreLayout>} />
              <Route path="/product/:slug" element={<StoreLayout><ProductDetail /></StoreLayout>} />
              <Route path="/about" element={<StoreLayout><InfoPage type="about" /></StoreLayout>} />
              <Route path="/contact" element={<StoreLayout><InfoPage type="contact" /></StoreLayout>} />
              <Route path="/privacy" element={<StoreLayout><PolicyPage type="privacy" /></StoreLayout>} />
              <Route path="/terms" element={<StoreLayout><PolicyPage type="terms" /></StoreLayout>} />
              <Route path="/shipping" element={<StoreLayout><PolicyPage type="shipping" /></StoreLayout>} />
              <Route path="/accessibility" element={<StoreLayout><PolicyPage type="accessibility" /></StoreLayout>} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </div>
          <AccessibilityWidget />
          <Toaster />
        </BrowserRouter>
      </SettingsProvider>
    </div>
  );
}

export default App;
